class Opportunity {
	id = null;
	vtiger_id = null;
	category = '';
	price = 0;
	web_highlighted = false;
	web_special = false;
	web_lowered_prices = false;
	web_appartments_top = false;
	web_houses_top = false;
	web_lofts_top = false;
	web_new = false;
	location_id = null;
	photos = [];
	videos = [];
	luxury = false;
	first_row = false;
	second_row = false;
	seaview = '';
	sea_distance = '';
	center_distance = '';
	sea_approach = '';
	orientation = [];
	hidden_info = false;
	videocall = false;
	exchanges = false;
	appartment_type = '';
	house_type = '';
	space_purpose = '';
	ground_type = '';
	level_no = '';
	position = '';
	ground_purpose = '';
	rooms_no = 0.0;
	room_no = '';
	bathrooms_with_no = '';
	area = 0.0;
	bathrooms_without_no = '';
	ground_length = '';
	toilet_no = '';
	ground_width = '';
	house_build_type = '';
	floor = '';
	total_floors = '';
	ground_area = 0.0;
	units_no = '';
	living_area = 0.0;
	nett_area = 0.0;
	year_built = '';
	build_type = '';
	tifacade = '';
	facade_width = 0.0;
	roof_state = '';
	roof_type = '';
	roof_build_type = '';
	roof_isolation = '';
	windows_type = '';
	windows_equipment = [];
	floors = [];
	approach_material = '';
	approach_type = [];
	renovation_year = '';
	infrastructure = [];
	object_data = [];
	shape = '';
	septic_tank_volume = 0.0;
	septic_tank = '';
	heating = '';
	additional_info = '';
	air_conditioning = false;
	ground_permits_and_confirmations = [];
	energy_class = '';
	alternative_energy = [];
	permits_and_confirmations = [];
	lodge_terrace = [];
	furniture_state = [];
	other_objects = [];
	pool_details = [];
	pool_size = 0.0;
	parking_type = [];
	parking_spaces = '';
	functionalities = [];
	tourism_income = '';
	reserve = false;
	reserve_amount = 0.0;
	watermarked_photos = [];
	total_area = 0.0;
	sales_stage = '';
	longitude = '';
	latitude = '';
	indomio_location = '';
	njuskalo_location = '';

	constructor(data) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}
	}
}

export default Opportunity;
